import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { BankAccount, ErrorResponse, ListResponse } from 'types';

const useBankAccounts = ({
  queries,
  enabled,
}: {
  queries: {
    transaction_method?: string;
    wallet?: string;
  };
  enabled?: boolean;
}): UseQueryResult<ListResponse<BankAccount>, ErrorResponse> => {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }

  return useQuery([`${url.bankAccounts}${queryParams}`], {
    enabled: enabled,
  });
};
export default useBankAccounts;
